export default __webpack_public_path__ + "static/media/Banking_Banner.a09484e5.png";